import { render, staticRenderFns } from "./CommonErrorModal.vue?vue&type=template&id=12b4da42&scoped=true&"
var script = {}
import style0 from "./CommonErrorModal.vue?vue&type=style&index=0&id=12b4da42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4da42",
  null
  
)

export default component.exports